import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DxButtonModule, DxCheckBoxModule } from 'devextreme-angular';
import { DxListModule } from 'devextreme-angular/ui/list';
import { DxButtonTypes } from 'devextreme-angular/ui/button';

@Component({
  selector: 'dk-calendar-list',
  templateUrl: './calendar-list.component.html',
  styleUrls: ['./calendar-list.component.scss'],
  standalone: true,
  imports: [
    DxListModule,
    DxCheckBoxModule,
    DxButtonModule,
    HttpClientModule,
    CommonModule,
  ],
})
export class CalendarListComponent implements OnInit {
  @Input() dataSource: Record<string, any>[];

  @Output() listSelectionChanged = new EventEmitter<any>();

  selectedItems: any[];

  constructor() {
  }

  ngOnInit() {
    this.selectedItems = [...this.dataSource.flatMap((el: any) => el.items)];
  }

  selectionChanged(item: any, isSelected: any) {
    const selected = this.selectedItems;
    this.selectedItems = isSelected
      ? [...selected, item]
      : selected.filter((el) => el !== item);
    this.listSelectionChanged.emit(this.selectedItems);
  }

  onAddClick(e: DxButtonTypes.ClickEvent) {
    e.event.stopImmediatePropagation();
  }
}
